"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledTypography = (0, styles_1.styled)(material_1.Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));
//# sourceMappingURL=styled.js.map